import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Clock, ArrowRight, X } from "lucide-react";

const STORAGE_KEY = "trial_banner_dismissed_at";

export default function TrialCountdown() {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const ts = parseInt(saved, 10);
      if (!Number.isNaN(ts) && Date.now() - ts < 1000 * 60 * 60 * 12) {
        setDismissed(true);
      }
    }
    let cancelled = false;
    const fetchState = async () => {
      try {
        const { data } = await api.get("/premium/trial");
        if (!cancelled) setData(data);
      } catch { /* ignore */ }
    };
    fetchState();
    const id = setInterval(fetchState, 1000 * 60 * 5); // refresh every 5 min
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (dismissed || !data || !data.is_trial_active) return null;
  // Only show banner during trial that came from /trial/start
  if (!data.used) return null;

  const days = data.days_left;
  const hours = data.hours_left;
  const isSoon = days <= 3;
  const dDay = days === 0 ? "Dernier jour" : `J-${days + 1}`;

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setDismissed(true);
  };

  return (
    <div
      className={`sticky top-0 z-30 ${isSoon ? "bg-red-600" : "bg-slate-900"} text-white`}
      data-testid="trial-countdown-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center gap-3">
        <Clock size={16} className="shrink-0" />
        <p className="text-sm flex-1 truncate">
          <strong>{dDay}</strong> · {hours} h restantes sur ton essai Premium gratuit.{" "}
          <span className="hidden sm:inline">Abonne-toi pour ne rien perdre — modèles, bons plans, sans pub.</span>
        </p>
        <Link
          to="/premium"
          data-testid="trial-cta-link"
          className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white text-slate-900 text-xs font-semibold hover:bg-slate-100 shrink-0"
        >
          Garder Premium <ArrowRight size={12} />
        </Link>
        <button
          onClick={handleDismiss}
          aria-label="Masquer"
          data-testid="trial-banner-dismiss"
          className="text-white/80 hover:text-white shrink-0"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
